import React from 'react';

/**
 * Unified status badge. Replaces the per-page getStatusBadge() functions
 * duplicated across ~13 files.
 *
 * Props:
 *   status    {string}  — the raw status string
 *   colorMap  {object}  — optional override map { status: 'bg-X text-Y' }
 *   label     {string}  — optional display override; defaults to status with underscores replaced
 */

const DEFAULT_COLOR_MAP = {
  // Ride statuses
  pending:     'bg-yellow-100 text-yellow-800',
  accepted:    'bg-blue-100 text-blue-800',
  arriving:    'bg-purple-100 text-purple-800',
  arrived:     'bg-indigo-100 text-indigo-800',
  in_progress: 'bg-cyan-100 text-cyan-800',
  completed:   'bg-green-100 text-green-800',
  cancelled:   'bg-red-100 text-red-800',
  // Payment statuses
  failed:      'bg-red-100 text-red-800',
  refunded:    'bg-purple-100 text-purple-800',
  // User / driver / admin account statuses
  active:      'bg-green-100 text-green-800',
  inactive:    'bg-gray-100 text-gray-800',
  suspended:   'bg-red-100 text-red-800',
  // Driver approval
  approved:    'bg-green-100 text-green-800',
  rejected:    'bg-red-100 text-red-800',
  // Payout
  paid:        'bg-green-100 text-green-800',
};

const StatusBadge = ({ status, colorMap, label }) => {
  const map = colorMap || DEFAULT_COLOR_MAP;
  const colorClass = map[status] || 'bg-gray-100 text-gray-800';
  const displayLabel = label ?? (status ? status.replace(/_/g, ' ') : '—');

  return (
    <span className={`status-badge ${colorClass}`}>
      {displayLabel}
    </span>
  );
};

export default StatusBadge;
